import { gql } from 'apollo-angular';

export const FIND_ALL_EXPENSES_WITH_PAGINATION = gql`
  query findAllExpensesWithPagination($input: ExpensePaginationInput) {
    findAllExpensesWithPagination(input: $input) {
      expenses {
        id
        expenseDate
        expenseType
        amount
        tax
        paidByData {
          firstName
          lastName
        }
        paymentMethod
        expenseStatus
      }
      total
      skip
      limit
    }
  }
`;

export const GET_EXPENSE_BY_ID = gql`
  query expense($id: Int!) {
    expense(id: $id) {
      id
      branchId
      expenseDate
      expenseType
      accountId
      accountData {
        id
        accountType
        accountName
      }
      amount
      tax
      paidBy
      paidByData {
        id
        firstName
        lastName
      }
      approvedBy
      approvedByData {
        id
        firstName
        lastName
      }
      paymentMethod
      bankAccountId
      bankAccountData {
        id
        bankName
      }
      creditCardId
      creditCardData {
        id
        cardName
      }
      isCheque
      chequeNo
      chequeDate
      referenceNo
      description
      attachmentUrl
      journalId
      journalData {
        id
        journalNo
        journalEntries {
          id
          journalId
          accountId
          debit
          credit
          description
        }
        createdAt
        updatedAt
        deletedAt
      }
      createdAt
      updatedAt
      deletedAt
      expenseStatus
    }
  }
`;

export const GET_EXPENSE_TYPES = gql`
  query getExpenseTypes {
    getExpenseTypes {
      id
      name
      description
    }
  }
`;

export const GET_PAYMENT_METHODS = gql`
  query getPaymentMethods {
    getPaymentMethods {
      id
      name
      description
    }
  }
`;

export const GET_EXPENSE_STATISTICS = gql`
  query getExpenseStatistics($input: ExpenseStatisticsInput) {
    getExpenseStatistics(input: $input) {
      totalExpenses
      totalAmount
      approvedAmount
      pendingAmount
      rejectedAmount
      monthlyData {
        month
        amount
        count
      }
    }
  }
`;